import axios, { AxiosRequestConfig, AxiosPromise } from "axios";

export type RequestType =
  | "get"
  | "GET"
  | "post"
  | "POST"
  | "put"
  | "PUT"
  | "patch"
  | "PATCH"
  | "delete"
  | "DELETE";

const createFormDataWithFiles = (
  files: File | File[],
  params?: { [key: string]: any }
) => {
  let data = new FormData();
  if (Array.isArray(files)) {
    files.forEach((f) => {
      data.append("files", f, f.name);
    });
  } else {
    data.append("file", files);
  }
  if (params) {
    Object.keys(params).forEach((key) =>
      data.append(key, JSON.stringify(params[key]))
    );
  }

  return data;
};

const buildRequest = async (
  url: string,
  method: RequestType = "GET",
  data?: { [key: string]: any } | string | number,
  timeout = 1000 * 60,
  files?: File | File[],
  onUploadProgress?: (progress: number) => any
) => {
  const http =
    window.location.protocol === "http:" &&
    !window.location.host.startsWith("localhost");

  let config: AxiosRequestConfig = {
    timeout,
    headers: { accept: "application/json" },
  };

  if (!files) {
    config.headers["content-type"] = "application/json";
  }

  if (http) {
    const token = localStorage.getItem("jwt");
    if (token) {
      config.headers = { Authorization: `Bearer ${token}` };
    }
  } else {
    config.withCredentials = true;
  }

  if (onUploadProgress) {
    config.onUploadProgress = (progressEvent) => {
      const completed = progressEvent.loaded / progressEvent.total;
      onUploadProgress(completed);
    };
  }

  let request: AxiosPromise;

  switch (method) {
    case "post":
    case "POST":
      if (files) {
        data = createFormDataWithFiles(files, data as { [key: string]: any });
      }
      request = axios.post(url, data, config);
      break;
    case "put":
    case "patch":
    case "PUT":
    case "PATCH":
      request = axios.put(url, data, config);
      break;
    case "delete":
    case "DELETE":
      request = axios.delete(url, { ...config, data });
      break;
    default:
      request = axios.get(url, { ...config, data });
  }

  return request;
};

export default buildRequest;
